import { getPostHogApiHost } from 'utils/posthog';
import { post, put } from '.';

export const updateUser = (user: Partial<Bizly.User>): Promise<Bizly.User> =>
    put(`users/profile`, user).then(res => res.user);

export const logOutUser = (userId: number): Promise<unknown> => post(`users/${userId}/logout`);

export const getUserFeatureFlags = async (userId: number): Promise<Record<string, boolean>> => {
    const response = await fetch(`${getPostHogApiHost()}/decide?v=3`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            distinct_id: userId,
            api_key: import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY,
        }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(
            `PostHog API error (${response.status}): ${data.error || data.message || JSON.stringify(data)}`
        );
    }

    return data.featureFlags ?? {};
};
